import FOIL_OPTIONS from '@/js/personalize-product/data/foils'
import FONT_OPTIONS from '@/js/personalize-product/data/fonts'
import POSITION_OPTIONS from '@/js/personalize-product/data/positions'
import { defineMessage } from 'react-intl'

export const PERSONALIZATION_FIELD_KEYS = {
    text: 'embossText',
    foil: 'embossFoil',
    font: 'embossFont',
    position: 'embossPosition'
}

/**
 * The Labels of these fields are important. If they change, notify Luis so that he can update the cart transform function, responsible for making sure these appear everywhere where they should (Invoice Order, Shopify Admin Order UI)
 */
const PERSONALIZATION_FIELDS = {
    [PERSONALIZATION_FIELD_KEYS.text]: {
        label: defineMessage({ defaultMessage: "Text" })
    },
    [PERSONALIZATION_FIELD_KEYS.foil]: {
        label: defineMessage({ defaultMessage: "Folie" }),
        options: FOIL_OPTIONS
    },
    [PERSONALIZATION_FIELD_KEYS.font]: {
        label: defineMessage({ defaultMessage: "Schriftart" }),
        options: FONT_OPTIONS
    },
    [PERSONALIZATION_FIELD_KEYS.position]: {
        label: defineMessage({ defaultMessage: "Positionierung" }),
        options: POSITION_OPTIONS
    }
}

export default PERSONALIZATION_FIELDS